module.exports = __webpack_public_path__ + "media/country_flags/gy-73ee84c1.png";